import React, { useMemo } from 'react';
import Img from './Img';
import useElementSize from '../hooks/useElementSize';
import { fillFrame } from '../utils/layout';

/**
 * Fills its box edge-to-edge from `pool`: one full-bleed portrait on
 * phones, one landscape or a row of 2–4 portraits on wide screens.
 * `load={false}` renders placeholder colours only (for off-screen slides).
 */
const CoverFill = ({ pool, altFor, load = true, eager = false, className = '' }) => {
  const [ref, { width, height }] = useElementSize();
  // Quantised so picks change only when the frame changes shape, not per pixel.
  const shape = width && height ? Math.round((width / height) * 8) / 8 : 0;

  const picks = useMemo(() => (shape ? fillFrame(pool, shape) : []), [pool, shape]);
  const aspectSum = picks.reduce((s, i) => s + i.aspect, 0);

  return (
    <div ref={ref} className={`coverFill ${className}`}>
      {picks.map((image) => {
        const share = image.aspect / aspectSum;
        return (
          <div key={image.src} className="coverFill__tile" style={{ flexGrow: share, '--ph': image.color }}>
            {load && (
              <Img
                image={image}
                alt={altFor(image)}
                eager={eager}
                sizes={`${Math.ceil((width * share) / 100) * 100}px`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CoverFill;
